import React, { Component, Fragment } from 'react';
import autoBind from 'react-autobind';
import StaticGrid from "@common/components/grid/staticGrid.component";
import { connect } from '@common/components/base.component';
import solicitarDocumentoSelector from "../store/solicitarDocumento.selectors";
import solicitarDocumentoActions from "../store/solicitarDocumento.actions";
import * as messages from '@/modules/common/app/helpers/common.messages';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const columns = [
      { fieldName: 'Documento', dataName: 'IdTipoDocumento', show: true, type: 'number' },
      { fieldName: 'Descrição Documento', dataName: 'TipoDocumento', show: true, type: 'text' },
      { fieldName: 'Orgão', dataName: 'IdOrgao', show: true, type: 'number' },
      { fieldName: 'Descrição Orgão', dataName: 'Orgao', show: true, type: 'text' },
    ];

    const order = [
      {
        fieldName: 'Documento',
        dataName: 'IdTipoDocumento',
        order: 'A',
      },
    ];

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: "RedeSIM.SolicitarDocumento.Solicitacao",
      applySearchOnLoad: true,
      isNotCheckable: true,
    };

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false
      }
    };

    const actions = [
        {
          type: 'disassociate',
          onClick: async dataItem => {
            const result = await _alert.confirm(messages.CONFIRMA_DESASSOCIAR, 'Desassociar Registro Selecionado');
            if (result) {
              this.props.solicitarDocumentoActions.removeGridSolicitarDocumento(dataItem);
            }
          },
        },
      ];

    this.config = {
      columns,
      actions,
      order,
      options,
      toolbar,
    };
  }

  render() {
    const { solicitarDocumento } = this.props.solicitarDocumentoSelector;
    const { GridSolicitarDocumento } = solicitarDocumento;

    return (
      <Fragment>
        <StaticGrid {...this.config} itens={GridSolicitarDocumento.asMutable()} />
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    solicitarDocumentoActions
  },
  selectors: {
    solicitarDocumentoSelector
  }
})(Container);
